import styled from "styled-components";
import { Link } from "react-router-dom";

export const StyledMenuSelectorLink = styled(Link)`
  position: relative;
`;

export const StyledIcon = styled.i`
  display: flex;
`;

export const StyledSelectedUnderline = styled.span`
  display: flex;
  border: 1px solid ${({ theme }) => theme.customTheme.palette.red.standard};
  position: absolute;
  top: 37px;
  right: -8px;
  width: 32px;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    top: 41px;
  }
`;

export const StyledNumber = styled.span`
  color: ${({ theme }) => theme.customTheme.palette.white.standard};
  border-radius: 50%;
  background-color: ${({ theme }) => theme.customTheme.palette.red.standard};
  position: absolute;
  bottom: 9px;
  left: 9px;
  height: ${({ theme }) => theme.customTheme.pxToRem(16)};
  width: ${({ theme }) => theme.customTheme.pxToRem(16)};

  text-align: center;
  vertical-align: middle;
  font-size: ${({ theme }) => theme.customTheme.pxToRem(12)};
  line-height: ${({ theme }) => theme.customTheme.pxToRem(16)};

  :visited {
    color: ${({ theme }) => theme.customTheme.palette.white.standard};
  }
`;
